import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import  NotesToFrontAutoFill  from '../modules/notes/models/notes-to-front-autofill/notes-to-front-autofill.model';

@Injectable({
  providedIn: 'root'
})
export class NotesToFrontService {

  constructor(private http: HttpClient) {
  }

    // Configuration
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getNotesToFrontAutofillModels(TDOCID:string): Observable<NotesToFrontAutoFill[]> {

    return this.http.get<NotesToFrontAutoFill[]>(`api/frontnotes/${TDOCID}/autofill/configuration`);
  }

  saveNotesAutoFillConfigurationItem(model: NotesToFrontAutoFill): Observable<any> {    
    return model.AutoFillID?
            this.http.put<any>(`api/frontnotes/autofill/${model.AutoFillID}`, model)
            : this.http.post<any>(`api/frontnotes/autofill`, model);
  }

  deleteNotesAutoFillConfigurationItem(model: NotesToFrontAutoFill): Observable<any> {    
    return this.http.delete<any>(`api/frontnotes/autofill/${model.AutoFillID}`);     
  }       
}
